module.exports = __webpack_public_path__ + "img/folder-icon.9eb9d79.png";